import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RG_TAKE_BREAK_CUSTOM_SELF_EXCLUSION_MESSAGE_FN: InjectionToken<() => string> = new InjectionToken<
  () => string
>('rgTakeBreakCustomSelfExclusionMessageLoaderFn');
